import { memo } from 'react';
import ResidentAvatar from './ResidentAvatar';
import calendarIcon from '../assets/calendar.svg';
import clockIcon from '../assets/clock.svg';
import hospitalIcon from '../assets/hospital.svg';
import sendIcon from '../assets/send.svg';

const W = "#ffffff";

/**
 * FallRecordRow Component - Memoized to prevent unnecessary re-renders
 * Displays a single fall record in the list
 */
const FallRecordRow = memo(({ 
  record, 
  isSelected, 
  isMobile, 
  onRecordClick,
  formatDateTime 
}) => {
  const { date, time } = formatDateTime(record.fall_ts);
  const residentName = record.resident_name || "Unknown Resident";
  const roomNumber = (record.location_id || "N/A").replace(/^ROOM-/, '');

  return (
        <div
      onClick={() => onRecordClick(record)}
      style={{
        display: isMobile ? "flex" : "grid",
        flexDirection: isMobile ? "column" : "row",
        gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr 1fr 1fr",
        gap: isMobile ? 8 : 12,
        background: "rgba(10, 26, 48, 0.95)",
        border: `2px solid ${isSelected ? '#4ade80' : '#ffffff'}`,
        opacity: isSelected ? 1 : 0.95,
        borderRadius: 12,
        padding: isMobile ? "10px 12px" : "8px 20px",
        fontSize: 14,
        alignItems: isMobile ? "flex-start" : "center",
        cursor: "pointer",
        transition: "all 0.2s",
      }}
    >
            {/* Date & Time */}
      <div style={{ display: "flex", alignItems: "center", gap: 6, flexWrap: "wrap" }}>
        <img src={calendarIcon} alt="calendar" style={{ width: 18, height: 18, filter: "brightness(0) invert(1)" }} />
        <span style={{ fontSize: 13 }}>{date}</span>
        <img src={clockIcon} alt="clock" style={{ width: 18, height: 18, filter: "brightness(0) invert(1)", marginLeft: 4 }} />
        <span style={{ fontSize: 13 }}>{time}</span>
      </div>

            {/* Resident Info */}
      <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
        <ResidentAvatar 
          photoS3Key={record.photo_s3_key}
          residentName={residentName}
          severity={record.severity}
          size={32}
        />
        <span style={{ fontSize: 13 }}>{residentName}</span>
      </div>

            {/* Room Number */}
      <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
        <img src={hospitalIcon} alt="room" style={{ width: 28, height: 28, filter: "brightness(0) invert(1)" }} />
        <span style={{ fontSize: 14, fontWeight: 600 }}>{roomNumber}</span>
      </div>

            {/* View Video Button */}
      <button
        style={{
          padding: "6px 12px",
          background: "transparent",
          border: "none",
          borderRadius: 8,
          color: W,
          fontSize: 13,
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          gap: 6,
          transition: "all 0.2s",
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.background = "rgba(255, 255, 255, 0.1)";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.background = "transparent";
        }}
      >
        <img src={sendIcon} alt="send" style={{ width: 28, height: 28, filter: "brightness(0) invert(1)" }} />
        <span style={{ fontSize: 14, fontWeight: 600 }}>View Video</span>
      </button>
    </div>
  );
}, (prevProps, nextProps) => {
  // Custom comparison function for memo
  // Only re-render if these specific props change
  return (
    prevProps.record.fall_id === nextProps.record.fall_id &&
    prevProps.isSelected === nextProps.isSelected &&
    prevProps.isMobile === nextProps.isMobile
  );
});

FallRecordRow.displayName = 'FallRecordRow';

export default FallRecordRow;
